var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lc-video" },
    [
      !_vm.isOldAndroid
        ? _c("video-player", {
            ref: "videoPlayer",
            attrs: { options: _vm.videoOptions }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOldAndroid
        ? _c("video", {
            ref: "videofile",
            attrs: {
              controls: "",
              src: _vm.video.video_url || _vm.video.url,
              preload: "auto"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4b64d78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4b64d78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LcVideo.vue
// module id = W9X/
// module chunks = 1